export default "__VITE_ASSET__BnPnT3J8__"